<template>
  <div class="ad-edit">
    <fixed-header :title="(isEdit?'编辑':'新增')+'收货地址'"></fixed-header>
    <div class="ad-edit__main-wrap scroll-touch">
      <section class="ad-edit__main">
        <div class="ad-edit__main-item">
          <div class="ad-edit__main-item-label">收货人</div>
          <input-item v-model="form.consignee" class="ad-edit__main-item-input" placeholder="收货人只能是汉字、字母和数字"
                      type="text"></input-item>
        </div>
        <div class="ad-edit__main-item">
          <div class="ad-edit__main-item-label">手机号码</div>
          <input-item v-model="form.mobile" class="ad-edit__main-item-input" type="number"></input-item>
        </div>
        <div class="ad-edit__main-item" @click="isShowCity=true">
          <div class="ad-edit__main-item-label">所在地区</div>
          <div v-if="showArea" class="ad-edit__main-item-input">{{ showArea }}</div>
          <div v-else class="ad-edit__main-item-icon">
            <i class="icon left_arrow"></i>
          </div>
        </div>
        <div class="ad-edit__main-detail">
          <div class="ad-edit__main-item-label">详细地址</div>
          <input-item v-model="form.address" class="ad-edit__main-item-input" placeholder="如道路、门牌号、小区"
                      type="text"></input-item>
        </div>
      </section>
      <section class="ad-edit__default">
        <div>设为默认地址</div>
        <div>
          <mt-switch v-model="form.isDefault"></mt-switch>
        </div>
      </section>
      <section v-if="isEdit" class="ad-edit__delete" @click="deleteAddress(form.addressId)">
        删除收货地址
      </section>
    </div>
    <div class="ad-edit__bottom" mg-stat-click mg-stat-custom="label=btn&cont=保存&direct=cntp&addr=" @click="submitForm">
      <button>保存</button>
    </div>
    <city-picker :data="form" :isShow="isShowCity" @cancel="cancel" @changeVisible="(val)=>{isShowCity=val}"
                 @confirm="getCity"></city-picker>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import InputItem from 'components/common/InputItem';
import CityPicker from 'components/common/Picker/CityPicker';
import _ from 'lodash';
import { removeSpaceChar } from 'utils/string';
import { hideMessageBox, isValidMobile } from 'utils';
import * as userApi from 'apis/user';


export default {
  components: {
    FixedHeader,
    InputItem,
    CityPicker,
  },
  data() {
    const {
      id: addressId,
    } = this.$route.query;
    const nowId = addressId ? Number(addressId) : 0;
    return {
      isEdit: !!nowId,
      nowId,
      isShowCity: false,
      isDefault: false,
      form: {
        consignee: '',
        mobile: '',
        province: {
          id: '',
          name: '',
        },
        city: {
          id: '',
          name: '',
        },
        district: {
          id: '',
          name: '',
        },
        address: '',
        addressId: 0,
        isDefault: false,
        gbType: 0,
      },
    };
  },
  created() {
    this.fetchAddressList();
  },
  computed: {
    showArea() {
      const {
        form: {
          province,
          city,
          district,
        },
      } = this;
      if (!province || !city || !district) {
        return null;
      }
      return `${province.name} ${city.name} ${district.name}`;
    },
  },
  methods: {
    removeSpaceChar,
    async fetchAddressList() {
      const data = await userApi.getAddressList();
      if (Array.isArray(data)) {
        if (this.isEdit) {
          const [val] = data.filter(f => f.addressId === this.nowId);
          val.isDefault = !!val.isDefault;
          this.form = val;
        } else if (!data.length) {
          this.form.isDefault = true;
        }
      }
    },
    cancel() {
      this.isShowCity = false;
    },
    getCity(data) {
      this.isShowCity = false;
      _.assign(this.form, data);
    },
    deleteAddress(addressId) {
      this.$message.confirm('确认删除?').then(() => {
        this.fetchDeleteAddress(addressId);
      });
    },
    async fetchDeleteAddress(addressId) {
      await userApi.deleteAddress({
        addressId,
      });
      this.toast('删除成功');
      this.$router.go(-1);
    },
    toast(message) {
      this.$toast({
        message,
        duration: 500,
      });
    },
    async submitForm() {
      const {
        form: {
          consignee,
          mobile,
          province,
          city,
          district,
          address,
          addressId,
          gbType,
          isDefault,
        },
      } = this;
      if (!consignee) {
        this.toast('请填写收货人');
        return;
      }
      if (!mobile) {
        this.toast('请填写手机号');
        return;
      }
      if (!isValidMobile(mobile)) {
        this.toast('请填写正确的手机号');
        return;
      }
      if (!province.id) {
        this.toast('请选择地区');
        return;
      }
      if (!address) {
        this.toast('请填写详细地址');
        return;
      }
      const form = {
        consignee,
        mobile,
        address,
        addressId,
        isDefault: Number(isDefault),
        province: province.id,
        city: city.id,
        district: district.id,
        gbType,
      };
      if (!addressId) {
        delete form.addressId;
      }
      this.$loading.open();
      try {
        const { addressId: nowId } = await userApi.editAddress(form);
        this.toast(addressId ? '编辑成功' : '添加成功');
        const {
          first_add,
          redirect,
          from,
          queryParams,
        } = this.$route.query;
        if (first_add === 1) {
          this.$router.push({
            path: '/pay',
            query: {
              addressId: nowId,
            },
          });
        } else if (redirect) {
          const queryParam = JSON.parse(queryParams);
          queryParam.addressId = nowId;
          this.$router.push({ path: `/${from}`, query: queryParam });
        } else {
          this.$router.go(-1);
        }
      } catch (error) {
        this.$message(`${error.message}`);
      }
      this.$loading.close();
    },
  },
  beforeDestroy() {
    hideMessageBox();
  },
};
</script>

<style lang="scss">
.ad-edit {
  height: 100%;
  box-sizing: border-box;

  &__main {
    &-wrap {
      height: 100%;

      section {
        margin-top: 30px;
        padding: 0 30px;
        background: #fff;
        border-radius: 20px;
      }
    }

    &-item {
      min-height: 96px;
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      font-size: 28px;
      justify-content: space-between;

      &-label {
        width: 150px;
        color: #9b9b9b;
        margin-right: 46px;
      }

      &-input {
        flex: 1;
      }

      &-icon {
        flex: 1;
        text-align: right;
      }

      input {
        font-size: 28px;
      }

      :last-child {
        border: none;
      }
    }
  }

  &__main-detail {
    @extend .ad-edit__main-item;
    align-items: flex-start;
    border: none;
    padding-top: 30px;
  }

  &__default {
    height: 96px;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #000000;
    justify-content: space-between;

    .mint-switch-core::before {
      background: #e5e5ea;
    }
  }

  &__delete {
    height: 96px;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #ff4c00;
  }

  &__bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 36px;
    background: #fff;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }
}
</style>
